import React from 'react';
import { Grid, Container } from '@material-ui/core';
import AdminBaseLayout from '../../../components/CabinetBaseLayout';
import { StaticChart } from '../../../components/Charts';

const MainView = () => (
  <AdminBaseLayout>
    <Container maxWidth="xl">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StaticChart />
        </Grid>
      </Grid>
    </Container>
  </AdminBaseLayout>
);

export default MainView;
